import { render } from "./PhoneLogin.vue?vue&type=template&id=e90ed806&scoped=true"
import script from "./PhoneLogin.vue?vue&type=script&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&lang=js"

import "./PhoneLogin.vue?vue&type=style&index=0&id=e90ed806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90ed806"]])

export default __exports__